import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';
import { anvspec as anvSpecs, Kode } from '../../Map/util/koder';
import Plus from '../../common/Icons/Plus';
import { neutral } from '../../../style/colors';

const AnvendelseSpecifikSelect = (props: IAnvendelseSpecifikSelectProps) => {
  const { show, toggledAnvspecs, addAnvspec } = props;
  const [filter, setFilter] = useState('');
  const filterInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (show && filterInputRef && filterInputRef.current) {
      filterInputRef.current.focus();
    }
  }, [show]);
  const onFilterChange = e => {
    setFilter(e.target.value);
  };
  const animation = useSpring({
    opacity: show ? 1 : 0,
  });
  const renderAnvspecs = () => {
    const filteredAnvspecs = anvSpecs.filter(a => {
      return (
        toggledAnvspecs.indexOf(a.kode) === -1 &&
        a.tekst.toLowerCase().indexOf(filter.toLowerCase()) > -1
      );
    });

    return filteredAnvspecs.map((anvspec: Kode) => {
      return (
        <SpecifikAnvendelse
          key={anvspec.kode}
          onClick={() => {
            addAnvspec(anvspec.kode);
          }}
        >
          <div>
            <Plus />
          </div>
          <div>{anvspec.tekst}</div>
        </SpecifikAnvendelse>
      );
    });
  };
  return (
    <animated.div
      style={{
        ...{
          pointerEvents: show ? 'auto' : 'none',
          position: 'absolute',
          zIndex: 3,
          top: 40,
          width: 260,
          left: 10,
        },
        ...animation,
      }}
    >
      <Arrow />
      <Main>
        <FilterWrapper>
          <FilterInput
            ref={filterInputRef}
            value={filter}
            onChange={onFilterChange}
            placeholder="Filtrér"
          ></FilterInput>
        </FilterWrapper>
        <ScrollWrapper>{renderAnvspecs()}</ScrollWrapper>
      </Main>
    </animated.div>
  );
};

const Arrow = styled.div`
  width: 0;
  height: 0;
  left: 50%;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #f8fbfe;
  margin: -2px auto;
  filter: drop-shadow(0 2px 10px rgba(38, 63, 87, 0.08));
`;
const Main = styled.div`
  background-color: #f8fbfe;
  z-index: 4;
  box-shadow: 0 2px 10px rgba(38, 63, 87, 0.16);
  height: 350px;
`;
const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  border-bottom: 1px solid #beceda;
`;
const FilterInput = styled.input`
  height: 35px;
  line-height: 35px;
  width: 95%;
  padding: 0 15px;
  border: 1px solid #e8eef4;
  :focus {
    outline: none;
    border: solid 2px #d5dde6;
  }
`;
const ScrollWrapper = styled.div`
  overflow-y: auto;
  max-height: 295px;
`;
const SpecifikAnvendelse = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  :hover {
    background-color: ${neutral[200]};
  }
  div:nth-child(1) {
    padding: 2px 12px;
  }
  div:nth-child(2) {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
interface IAnvendelseSpecifikSelectProps {
  show: boolean;
  toggledAnvspecs: Array<number>;
  addAnvspec: Function;
}
export default AnvendelseSpecifikSelect;
